import React, { useEffect, useState } from 'react';
import { Stack } from 'react-bootstrap';
import { useGetSavedTalentListQuery } from 'services';
import useAuthStore from 'store/auth';
import CandidateDetailBox from 'components/Common/Candidates/CandidateDetailBox';
import PaginationBox from 'components/PaginationBox';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const SavedTalentList: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const order = 'DESC';

	const { user }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});

	const { data: { docs = [], meta = {} } = {}, refetch } = useGetSavedTalentListQuery({
		currentPage,
		order,
		userId: user?.userId,
	});

	const setCurrentPageFunction = (pageNum: number) => {
		setCurrentPage(pageNum);
	};

	useEffect(() => {
		refetch();
		window.scrollTo({
			top: 0,
			behavior: 'instant',
		});
	}, [currentPage]);

	return (
		<div className="white-box bg-white">
			<Stack className="gap-3 gap-md-4">
				<div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
					<div className="list-heading">
						<h5 className="fw-bold">{translate('Company.savedTalent')}</h5>
					</div>
				</div>

				<Stack className="gap-4">
					{docs?.length > 0 ? (
						docs?.map((res: any) => (
							<CandidateDetailBox
								key={`${res?.userId}-${res?.name}`}
								applicantList={res}
								userId={user?.userId}
								actions={false}
								refetch={refetch}
							/>
						))
					) : (
						<Stack className="posted-job-box">
							<p className="mb-0">{translate('Company.noSavedTalent')}</p>
						</Stack>
					)}
				</Stack>
				{meta?.totalDocs > meta?.limit && (
					<PaginationBox
						totalData={meta?.totalDocs}
						limit={meta?.limit}
						page={currentPage}
						setCurrentPage={setCurrentPageFunction}
					/>
				)}
			</Stack>
		</div>
	);
};

export default SavedTalentList;
